import cianMetrics from '@cian/metrics';

export default angular.module('cian.newbuild.filter.statsService', [])
  .provider('StatsService', () => {
    const setMetric = (name) => {
      cianMetrics.add(name);
    };

    return {
      setMetric,
      $get: ['$log', $log => {
        return {
          setMetric,
          sendMetric: (prefix, name, value) => {
            if (process.env.ENABLE_METRICS) {
              cianMetrics.send([{
                name: `${prefix}.${name}`,
                type: 'timer',
                value: value
              }]);
            } else {
              $log.debug('Send metric', name, value);
            }
          },
          sendStats: (prefix) => {
            if (process.env.ENABLE_METRICS) {
              cianMetrics.waitForAllBrowserMetrics(() => {
                const metrics = cianMetrics.collect(prefix);
                if (process.env.BUILD_NAME) {
                  metrics.push({
                    name: 'versions.' + prefix + '.' + process.env.BUILD_NAME.toLowerCase(),
                    type: 'counter',
                    value: 1,
                  });
                }
                cianMetrics.send(metrics);
              });
            } else {
              $log.debug('Send metrics', cianMetrics.collect(prefix));
            }
          }
        }
      }]
    }
  })
  .name;



// WEBPACK FOOTER //
// ./src/serp/services/stats.service.provider.js